/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { AnalyticsWidgetComp, Header } from '../components';
import { useSMProductAnalyticsGetPageContent } from '../machines/pageContent';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';

import { AnalyticsService } from '../services';
import { VApplication } from '@/application';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.AnalyticsService') as AnalyticsService;
};

export const ContainerComm = (props: any) => {
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const {
    productAnalyticsSend,
    productAnalyticsState,
    productAnalyticsPageMachine,
  } = useSMProductAnalyticsGetPageContent({});

  const onRefresh = () => {
    productAnalyticsSend('TRIGGER_REFRESH', {});
  };

  console.log('productAnalyticsState', productAnalyticsState);

  const _renderPage = () => {
    if (productAnalyticsState?.matches('RENDER_PAGE')) {
      return (
        <>
          <AnalyticsWidgetComp
            {...(productAnalyticsState?.event?.data?.value || {})}
          />
          <StateOSD
            image="https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/team_work_2_black.png"
            titleNormalText={'Coming Soon 🚀🚀🚀'}
            description={'We are building this while we speak !'}
          />
        </>
      );
    }
    if (productAnalyticsState?.matches('GET_PAGE_CONTENT')) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.overViewLoading || {})}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onRefreshClick={onRefresh}
          />
        </>
      );
    }
    return null;
  };

  return (
    <>
      {_renderHeader()}
      {_renderPage()}
      {/*<StateOSD*/}
      {/*  image="https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/team_work_2_black.png"*/}
      {/*  titleNormalText={"Coming Soon 🚀🚀🚀"}*/}
      {/*  description={"We are building this while we speak !"}*/}
      {/*/>*/}
    </>
  );
};
